export const TRACKING_ACTIONS_KEYS = {
  addResultToLocalStorageCheckout: 'addResultToLocalStorageCheckout',
  moveResultToSessionStorage: 'moveResultToSessionStorage',
  removeLocalStorageCheckout: 'removeLocalStorageCheckout',
  loadResultId: 'loadResultId',
  saveResultIdToLocalStorage: 'saveResultIdToLocalStorage',
  saveResultToLocalStorage: 'saveResultToLocalStorage',
  saveItemToLocalStorageWithURL: 'saveItemToLocalStorageWithURL',
  trackClick: 'trackClick',
  trackClearFilters: 'trackClearFilters',
  trackPendingURLClick: 'trackPendingURLClick',
  trackQuery: 'trackQuery',
  trackShow: 'trackShow',
  trackAddToCartOnProductPage: 'trackAdd2cartOnProductPage',
  trackAddToCartOnResult: 'trackAddToCartOnResult',
  trackFilter: 'trackFilter',
  trackSort: 'trackSort',
  trackColumnsChange: 'trackColumnsChange',
  trackResultsEnd: 'trackResultsEnd',
  trackOpen: 'trackOpen',
  trackClose: 'trackClose',
  trackCheckout: 'trackCheckout',
  trackToggleWishlist: 'trackToggleWishlist'
} as const;

export const TRACKING_MUTATIONS_KEYS = {
  saveProductPageResultId: 'saveProductPageResultId',
  setResultsEnd: 'setResultsEnd',
  setQueryOrigin: 'setQueryOrigin'
} as const;

export const EVENTS_CONTEXT = {
  PDP: 'PDP',
  SRP: 'SRP'
} as const;
